/* @flow */
/**
 * External dependencies
 */
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import inboxes from './inboxes';
import theme from './theme';
import user from './user';
import video from './video';

/**
 * Flow
 */
import type { Reducer } from 'redux';

const getReducers = ( extraReducers: { [key: string]: Reducer<*, *> } ) => {
	return combineReducers( {
		inboxes,
		theme,
		user,
		video,
		...extraReducers,
	} );
};

export default getReducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js